import React from "react";
import PageHero from "../components/PageHero";
import { BRAND, STATS } from "../mock/mock";
import { useContent } from "../context/ContentContext";
import { CheckCircle2 } from "lucide-react";
import CTASection from "../components/CTASection";

export default function About() {
  const { brand = BRAND, stats = STATS } = useContent();
  const values = [
    { title: "Uzmanlık", desc: "Derin birikim ve sektör deneyimi." },
    { title: "Güven", desc: "Şeffaf süreç, net raporlama ve dürüst ilişki." },
    { title: "Çözüm Odaklılık", desc: "Her işletmeye özel, uygulanabilir çözümler." },
    { title: "Süreklilik", desc: "Başvurudan sonuçlara kadar uçtan uca destek." }
  ];
  return (
    <>
      <PageHero
        kicker="HAKKIMIZDA"
        title="İşletmelerin güvenilir çözüm ortağı."
        subtitle={`${brand.shortName} olarak yatırım teşvik, Ar-Ge ve proje danışmanlığında Türkiye'nin güvenilir çözüm ortağı.`}
      />
      <section className="py-20 lg:py-28 bg-[#0a0a0a]">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-10 grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <span className="text-[11px] tracking-[0.4em] text-[#B87333]">MİSYONUMUZ</span>
            <h2 className="mt-4 font-serif-display text-[#f5ede1] text-4xl lg:text-5xl leading-tight">
              İşletmelerin potansiyelini açığa çıkarıyoruz.
            </h2>
          </div>
          <div className="md:col-span-7 space-y-5 text-[#a89a85] leading-relaxed">
            <p>
              {brand.shortName}, kuruluşundan bu yana işletmelerin yatırım ve büyüme hedeflerine ulaşması için stratejik danışmanlık sunmaktadır.
              Deneyimli ekibimiz; teşvik analizi, başvuru yönetimi ve strateji geliştirme aşamalarında üst düzey uzmanlık sunar.
            </p>
            <p>
              Müşterilerimizin başarısı bizim başarımızdır. Şeffaf süreç, ölçülebilir sonuçlar ve uzun vadeli ortaklık bakışımızla her projeyi tamamlıyoruz.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 lg:py-24 bg-[#0d0b09]">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
          <div className="grid md:grid-cols-4 gap-px bg-[#B87333]/15">
            {stats.concat([{ value: 21, suffix: "+", label: "Yıllık Deneyim" }]).map((s, i) => (
              <div key={i} className="bg-[#0d0b09] p-10 text-center">
                <div className="font-serif-display text-[#B87333] text-5xl lg:text-6xl">
                  {s.value}
                  <span className="text-3xl text-[#D4A574] ml-1">{s.suffix}</span>
                </div>
                <div className="mt-3 text-[#f5ede1] text-sm tracking-wider">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 lg:py-28 bg-[#0a0a0a]">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
          <div className="max-w-2xl mb-14">
            <div className="flex items-center gap-3 mb-5">
              <span className="divider-line" />
              <span className="text-[11px] tracking-[0.4em] text-[#B87333]">DEĞERLERİMİZ</span>
            </div>
            <h2 className="font-serif-display text-[#f5ede1] text-4xl lg:text-5xl leading-tight">
              Biz neye inanıyoruz?
            </h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
            {values.map((v, i) => (
              <div key={i} className="border border-[#B87333]/20 p-8 bg-[#0d0b09] hover:border-[#B87333] transition-colors duration-500">
                <CheckCircle2 className="w-6 h-6 text-[#B87333] mb-6" strokeWidth={1.25} />
                <h3 className="font-serif-display text-[#f5ede1] text-2xl mb-3">{v.title}</h3>
                <p className="text-[#a89a85] text-sm leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <CTASection />
    </>
  );
}
